export default {
	DATE_PLACEHOLDER: 'YYYY-MM-DD'
};